var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRevenueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 37,
    height: 37,
    rx: 7.5,
    transform: "matrix(-1 0 0 1 37 0)",
    stroke: "url(#paint0_linear_1346_43032)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.19 9H14.81C11.17 9 9 11.17 9 14.81V23.18C9 26.83 11.17 29 14.81 29H23.18C26.82 29 28.99 26.83 28.99 23.19V14.81C29 11.17 26.83 9 23.19 9ZM14.63 25.15C14.63 25.56 14.29 25.9 13.88 25.9C13.47 25.9 13.13 25.56 13.13 25.15V23.08C13.13 22.67 13.47 22.33 13.88 22.33C14.29 22.33 14.63 22.67 14.63 23.08V25.15ZM19.75 25.15C19.75 25.56 19.41 25.9 19 25.9C18.59 25.9 18.25 25.56 18.25 25.15V21C18.25 20.59 18.59 20.25 19 20.25C19.41 20.25 19.75 20.59 19.75 21V25.15ZM24.87 25.15C24.87 25.56 24.53 25.9 24.12 25.9C23.71 25.9 23.37 25.56 23.37 25.15V18.93C23.37 18.52 23.71 18.18 24.12 18.18C24.53 18.18 24.87 18.52 24.87 18.93V25.15ZM24.87 15.77C24.87 16.18 24.53 16.52 24.12 16.52C23.71 16.52 23.37 16.18 23.37 15.77V14.8C20.82 17.42 17.63 19.27 14.06 20.16C14 20.18 13.94 20.18 13.88 20.18C13.54 20.18 13.24 19.95 13.15 19.61C13.05 19.21 13.29 18.8 13.7 18.7C17.07 17.86 20.07 16.09 22.45 13.59H21.2C20.79 13.59 20.45 13.25 20.45 12.84C20.45 12.43 20.79 12.09 21.2 12.09H24.13C24.17 12.09 24.2 12.11 24.24 12.11C24.29 12.12 24.34 12.12 24.39 12.14C24.44 12.16 24.48 12.19 24.53 12.22C24.56 12.24 24.59 12.25 24.62 12.27C24.63 12.28 24.63 12.29 24.64 12.29C24.68 12.33 24.71 12.37 24.74 12.41C24.77 12.45 24.8 12.48 24.81 12.52C24.83 12.56 24.83 12.6 24.84 12.65C24.85 12.7 24.87 12.75 24.87 12.81C24.87 12.82 24.88 12.83 24.88 12.84V15.77H24.87Z",
    fill: "currentColor"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1346_43032",
    x1: 19,
    y1: 0,
    x2: 19,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A79D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EC282"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenueIcon);
export default __webpack_public_path__ + "static/media/revenueIcon.f1f3a8e1aacc3801fe5ed88090847864.svg";
export { ForwardRef as ReactComponent };